import { IApplicationState } from '../../../../../../types/types';
import { TDriveDocId } from '../../../../../../types/rest/IRestDriveDoc';

export const getReplyAttachmentId = (state: IApplicationState): TDriveDocId => {
    return state.comments.replyAttachmentId;
}
